import Reveal from "@/components/torq/Reveal";

const DIVISIONS = [
  {
    n: "01",
    name: "MEN'S OPEN",
    tag: "SINGLES",
    fee: "₹4,499",
    d: "The full circuit, man against the clock. Every station, every kilometre, yours alone.",
    tid: "mens-open",
    rid: "MENS_OPEN",
  },
  {
    n: "02",
    name: "WOMEN'S OPEN",
    tag: "SINGLES",
    fee: "₹4,499",
    d: "The full circuit, no excuses. Own all seven stations and the run between them.",
    tid: "womens-open",
    rid: "WOMENS_OPEN",
  },
  {
    n: "03",
    name: "MEN'S DOUBLES",
    tag: "TEAM OF 2",
    fee: "₹6,999",
    d: "Split the stations, share the run. One result, two names on it.",
    tid: "mens-doubles",
    rid: "MENS_DOUBLES",
  },
  {
    n: "04",
    name: "WOMEN'S DOUBLES",
    tag: "TEAM OF 2",
    fee: "₹6,999",
    d: "Two athletes, one circuit, one clock. The loudest corner of the arena.",
    tid: "womens-doubles",
    rid: "WOMENS_DOUBLES",
  },
  {
    n: "05",
    name: "MIXED DOUBLES",
    tag: "TEAM OF 2 — 1 MALE + 1 FEMALE",
    fee: "₹6,999",
    d: "One man, one woman, one shared clock. Balance the stations, break the circuit together.",
    tid: "mixed-doubles",
    rid: "MIXED_DOUBLES",
  },
];

export default function Divisions({ onReserve }) {
  return (
    <section
      id="divisions"
      className="border-b border-[#2e2e2a] px-6 lg:px-12 py-24 lg:py-32"
      data-testid="divisions-section"
    >
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.35em] text-[#ff5a1f] mb-10" data-testid="divisions-overline">
          03 / DIVISIONS & FEES
        </p>
      </Reveal>
      <div className="grid sm:grid-cols-2 xl:grid-cols-5 gap-px bg-[#2e2e2a] border border-[#2e2e2a]">
        {DIVISIONS.map((d, i) => (
          <Reveal key={d.tid} delay={i * 0.06} className="h-full">
            <div
              data-testid={`division-card-${d.tid}`}
              onClick={() => onReserve(d.rid)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && onReserve(d.rid)}
              className="h-full flex flex-col justify-between gap-10 bg-[#161614] p-8 lg:p-10 transition-colors duration-300 hover:bg-[#1e1e1c] group cursor-pointer"
            >
              <div>
                <p className="font-mono text-[11px] tracking-[0.25em] text-[#6e6e6a] group-hover:text-[#a3a39f] transition-colors">
                  {d.n} — {d.tag}
                </p>
                <h3
                  className="mt-6 font-display font-extrabold uppercase text-3xl lg:text-4xl leading-none"
                  data-testid={`division-title-${d.tid}`}
                >
                  {d.name}
                </h3>
                <p className="mt-4 font-display font-bold text-2xl text-[#ff5a1f]" data-testid={`division-fee-${d.tid}`}>
                  {d.fee}
                </p>
                <p className="mt-4 text-sm leading-relaxed text-[#a3a39f]" data-testid={`division-copy-${d.tid}`}>
                  {d.d}
                </p>
              </div>
              <p className="font-mono text-[10px] tracking-[0.25em] text-[#6e6e6a] group-hover:text-[#f0eee4] transition-colors">
                PAY & RESERVE →
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div
          onClick={() => onReserve("SPECTATOR")}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && onReserve("SPECTATOR")}
          data-testid="division-card-spectator"
          className="border border-t-0 border-[#2e2e2a] bg-[#161614] flex flex-wrap items-center justify-between gap-4 px-8 lg:px-10 py-6 cursor-pointer hover:bg-[#1e1e1c] transition-colors group"
        >
          <div className="flex items-baseline gap-6 flex-wrap">
            <span className="font-display font-extrabold uppercase text-2xl lg:text-3xl leading-none" data-testid="division-title-spectator">
              SPECTATOR PASS
            </span>
            <span className="font-mono text-[10px] tracking-[0.25em] text-[#6e6e6a]">
              NOT RACING? WATCH & CHEER
            </span>
          </div>
          <div className="flex items-baseline gap-6">
            <span className="font-display font-bold text-2xl text-[#ff5a1f]" data-testid="division-fee-spectator">
              FREE
            </span>
            <span className="font-mono text-[10px] tracking-[0.25em] text-[#6e6e6a] group-hover:text-[#f0eee4] transition-colors">
              REGISTER FREE →
            </span>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
